class ProductModal extends ModalDialog {
  constructor() {
    super();
    this._navigationSetup = false;
  }
  hide() {
    super.hide();
  }
  show(opener) {
    super.show(opener);
    this.showActiveMedia();
    setTimeout(() => this.setupNavigation(), 50);
  }
  showActiveMedia() {
    const mediaId = this.openedBy.getAttribute("data-media-id");
    this.querySelectorAll('.modal-image-wrapper').forEach((wrapper) => {
      wrapper.style.display = wrapper.getAttribute('data-media-id') === mediaId ? 'flex' : 'none';
    });
  }
  setupNavigation() {
    if (this._navigationSetup) return;
    this._navigationSetup = true;

    const self = this;
    const prevBtn = this.querySelector('.modal-nav-prev');
    const nextBtn = this.querySelector('.modal-nav-next');
    const wrappers = Array.from(this.querySelectorAll('.modal-image-wrapper'));
    
    if (!prevBtn || !nextBtn || wrappers.length === 0) return;

    // ZOOM SEMPLICE CON ROTELLA - AL PUNTO DEL CURSORE
    wrappers.forEach((wrapper) => {
      const imgElement = wrapper.querySelector('img') || wrapper.querySelector('deferred-media');
      if (!imgElement) return;
      
      let currentZoom = 1;
      let cursorX = 50;
      let cursorY = 50;
      
      // Traccia posizione cursore
      wrapper.addEventListener('mousemove', (e) => {
        const rect = wrapper.getBoundingClientRect();
        cursorX = ((e.clientX - rect.left) / rect.width) * 100;
        cursorY = ((e.clientY - rect.top) / rect.height) * 100;
        imgElement.style.transformOrigin = `${cursorX}% ${cursorY}%`;
      });
      
      // BLOCCA CHIUSURA MODALE SU QUALSIASI CLICK NEL WRAPPER
      wrapper.addEventListener('click', (e) => {
        e.stopImmediatePropagation();
        e.preventDefault();
      }, true);
      
      // Click: toggle zoom 1x ↔ 3x
      imgElement.addEventListener('click', (e) => {
        e.stopImmediatePropagation();
        e.preventDefault();
        
        currentZoom = currentZoom === 1 ? 3 : 1;
        imgElement.style.transformOrigin = `${cursorX}% ${cursorY}%`;
        imgElement.style.transform = `scale(${currentZoom})`;
      }, true);
      
      // Zoom al cursore con rotella
      wrapper.addEventListener('wheel', (e) => {
        e.stopImmediatePropagation();
        e.preventDefault();
        
        const zoomStep = 0.2;
        currentZoom = e.deltaY < 0 ? currentZoom + zoomStep : currentZoom - zoomStep;
        currentZoom = Math.max(1, Math.min(3, currentZoom));
        
        imgElement.style.transformOrigin = `${cursorX}% ${cursorY}%`;
        imgElement.style.transform = `scale(${currentZoom})`;
      }, { passive: false, capture: true });
    });
    
    let currentIndex = wrappers.findIndex(w => w.style.display !== 'none');
    if (currentIndex === -1) currentIndex = 0;
    
    const updateDisplay = (index) => {
      wrappers.forEach((w, i) => {
        w.style.display = i === index ? 'flex' : 'none';
      });
    };
    
    const handlePrev = (e) => {
      e.stopImmediatePropagation();
      e.preventDefault();
      currentIndex = (currentIndex - 1 + wrappers.length) % wrappers.length;
      updateDisplay(currentIndex);
    };
    
    const handleNext = (e) => {
      e.stopImmediatePropagation();
      e.preventDefault();
      currentIndex = (currentIndex + 1) % wrappers.length;
      updateDisplay(currentIndex);
    };
    
    prevBtn.addEventListener('click', handlePrev, true);
    nextBtn.addEventListener('click', handleNext, true);
    
    prevBtn.addEventListener('pointerup', (e) => {
      e.stopImmediatePropagation();
      e.preventDefault();
    }, true);
    
    nextBtn.addEventListener('pointerup', (e) => {
      e.stopImmediatePropagation();
      e.preventDefault();
    }, true);
    
    // Tastiera: frecce sinistra/destra
    document.addEventListener('keydown', (e) => {
      if (!self.hasAttribute('open')) return;
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        currentIndex = (currentIndex - 1 + wrappers.length) % wrappers.length;
        updateDisplay(currentIndex);
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        currentIndex = (currentIndex + 1) % wrappers.length;
        updateDisplay(currentIndex);
      }
    });
  }
}

if (!customElements.get('product-modal')) customElements.define('product-modal', ProductModal);